// extracted by mini-css-extract-plugin
export default {"infoBox":"InfoBox_infoBox__j9Ds-","lightSymbol":"InfoBox_lightSymbol__9pNol","infoText":"InfoBox_infoText__P7qpi"};